import { FileUploader, FileUploaderOptions, FileLikeObject, FileItem } from "ng2-file-upload";
import { Servizio } from ".";
import { AlertService } from "app/services/alert.service";

export class DocumentiImmobileUploader {

    uploader: FileUploader;
    servizio: Servizio;

    constructor(allowedFileType: string[], realAllowedFileType: string[], maxFileSize: number, queueLimit: number, servizio: Servizio, notification: AlertService) {
        this.uploader = new FileUploader({});
        let options: FileUploaderOptions = this.uploader.options;
        options.allowedFileType = allowedFileType;
        options.maxFileSize = maxFileSize;
        options.queueLimit = queueLimit;
        this.uploader.setOptions(options);
        this.uploader.onAfterAddingFile = (item: FileItem) => {
            if(!realAllowedFileType.includes( item.file.name.split('.')[item.file.name.split('.').length-1].toLocaleLowerCase()) )
            {
                notification.error('Non è possibile caricare un file del tipo ' + item.file.name.split('.')[item.file.name.split('.').length-1] +
                                        '. I tipi permessi sono ' + realAllowedFileType + '.', true, 10000);
                item.remove();
            }
        }
        this.uploader.onWhenAddingFileFailed = (item: FileLikeObject, filter: any, options: FileUploaderOptions) => {
            let errors: string = '';
            if(!realAllowedFileType.includes( item.name.split('.')[item.name.split('.').length-1].toLocaleLowerCase()) )
            {
                errors += 'Non è possibile caricare un file del tipo ' + item.name.split('.')[item.name.split('.').length-1] +
                                    '. I tipi permessi sono ' + realAllowedFileType + '.';
            }
            if(item.size > options.maxFileSize)
            {
                errors += ' Non è possibile caricare un file con peso maggiore di ' + (options.maxFileSize / 1024 / 1024) + ' MB.';
            }
            if(errors != '')
            {
                notification.error(errors, true, 10000);
            }
        }

        this.servizio = servizio;
    }
}



// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/models/documenti-immobile-uploader.ts